import React, { useState } from "react";
import "../../InvoiceModal.css";
import { MdOutlineContentCopy } from "react-icons/md";
import { FcCheckmark } from "react-icons/fc";
import StatusIcons from "../../../../Components/StatusIcons/StatusIcons";
import { MdOutlineHistory } from "react-icons/md";
import Tooltip from "../../../../Components/Tooltip/Tooltip";
import ShipmentHistoryModal from "../../../ShipmentHistoryModal/ShipmentHistoryModal";
import HyperLink from "../../../HyperLink/HyperLink";
import { useTranslation } from "react-i18next";

const ShipmentDetails = ({ data, type = "Show" }) => {
  const { t } = useTranslation("finances");
  const [copied, setCopied] = useState(false);
  const [detailHistoryModal, setDetailHistoryModal] = useState(false);

  const handleCopy = () => {
    let shipmentIds = [];
    for (let i = 0; i < data?.c_p_shipment_details.length; i++) {
      let shipmentId = data?.c_p_shipment_details[i]?.shipment_tracking_id;
      shipmentIds.push(shipmentId);
    }
    let shipmentIdsString = shipmentIds.join(",\n");
    navigator.clipboard
      .writeText(shipmentIdsString)
      .then(() => {
        setCopied("sid");
      })
      .catch((error) => {
        console.error(
          "Failed to copy shipment tracking IDs to clipboard: " + error,
        );
      });

    setTimeout(() => setCopied(false), 2000);
  };

  const handleCopyParcelId = () => {
    let parcelIds = [];
    data?.shipment_details.map((item) => {
      parcelIds.push(item?.parcel_id);
    });
    // for (let i = 0; i < data?.parcel_id?.length; i++) {
    //   let parcelId = data?.parcel_id[i] ?? "";
    //   parcelIds.push(parcelId);
    // }
    let parcelIdsString = parcelIds.join(",\n");
    navigator.clipboard
      .writeText(parcelIdsString)
      .then(() => {
        setCopied("pid");
      })
      .catch((error) => {
        console.error("Failed to copy parcel IDs to clipboard: " + error);
      });

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <ShipmentHistoryModal
        open={detailHistoryModal}
        setOpen={setDetailHistoryModal}
      />
      <div className="invmodal__shipment_details">
        <div className="invmodal__shipment_detailshding">
          {t("invoice.details.title")}
        </div>
        <table className="invmodal__shdetails_table">
          <thead>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.details.carrier")}
            </th>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.details.service")}
            </th>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.details.type")}
            </th>
            {type === "admin" && (
              <>
                <th className="invmodal__shdetails_tablehd">
                  {t("invoice.details.account")}
                </th>
                <th className="invmodal__shdetails_tablehd">
                  {t("invoice.details.payment")}
                </th>
              </>
            )}
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.details.pickupRef")}
            </th>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.details.pickupDetails")}
            </th>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.details.packages")}
            </th>
          </thead>
          <tbody>
            {" "}
            <tr>
              {" "}
              <td className="invmodal__shdetails_tableitem">
                <img
                  src={data?.shipping_company?.shipping_company?.logo_url}
                  className="invmodal__shdetailgi_carrlogo"
                />
              </td>
              <td className="invmodal__shdetails_tableitem">
                {data?.service_type}
              </td>
              <td className="invmodal__shdetails_tableitem">
                {data?.shipment_type}
              </td>
              {type === "admin" && (
                <>
                  <td className="invmodal__shdetails_tableitem">
                    {data?.shipping_company?.account_name ??
                      t("invoice.details.defaultAccount")}
                  </td>
                  <td className="invmodal__shdetails_tableitem">
                    {data?.by_card == "1"
                      ? t("invoice.details.byCard")
                      : t("invoice.details.byBalance")}
                  </td>
                </>
              )}
              <td className="invmodal__shdetails_tableitem">
                {data?.PickupID ?? "-"}
              </td>
              <td className="invmodal__shdetails_tableitem">
                {data?.PickupDate ? (
                  <>
                    {data.PickupDate.slice(0, 10)}
                    {data.readyopentime && ` ${data.readyopentime.slice(0, 5)}`}
                    {data.readyopentime && data.readyclosetime && " - "}
                    {data.readyclosetime && data.readyclosetime.slice(0, 5)}
                  </>
                ) : (
                  "-"
                )}
              </td>
              <td className="invmodal__shdetails_tableitem">
                {data?.shipment_details?.length ?? "-"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="invmodal__shdetails_content  package__details_row_custom">
        <div className="invmodal__shipment_packagedetails_heading">
          {t("invoice.details.packagesDetail")}
        </div>
        <div className="invmodal__shdetails_cntleft">
          <div className="invmshdetails_cnleft_heading">
            {t("invoice.details.declared")}
          </div>
          <table className="invmshdetails_cnleft_table">
            <thead>
              <th className="invmodal__shdetails_tablehd content_center">#</th>
              <th className="invmodal__shdetails_tablehd">
                {t("invoice.details.description")}
              </th>
              <th className="invmodal__shdetails_tablehd ">
                {type !== "Print" ? (
                  <div className="invmodal__shdetails_tablehdinner ">
                    {t("invoice.details.parcelTrackingId")}{" "}
                    {data?.parcel_id?.length && copied !== "pid" ? (
                      <Tooltip title={t("invoice.details.copyParcelIds")}>
                        <span
                          className="invmodal__shdetails_modaltxtrtcopy"
                          onClick={handleCopyParcelId}
                        >
                          <MdOutlineContentCopy
                            size={16}
                            style={{ marginLeft: "10px" }}
                          />
                        </span>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                    {data?.parcel_id?.length && copied === "pid" ? (
                      <span className="invmodal__shdetails_modaltxtrtcopy">
                        <FcCheckmark size={16} style={{ marginLeft: "10px" }} />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  t("invoice.details.parcelId")
                )}
              </th>
              <th className="invmodal__shdetails_tablehd">
                {t("invoice.details.parcelStatus")}
              </th>
              {data?.c_p_shipment_details?.length > 0 && (
                <th className="invmodal__shdetails_tablehd">
                  {type !== "Print" ? (
                    <div className="invmodal__shdetails_tablehdinner ">
                      {t("invoice.details.carrierTracking")}
                      {data?.c_p_shipment_details?.length &&
                      copied !== "sid" ? (
                        <Tooltip title={t("invoice.header.copyTrackingIds")}>
                          <span
                            className="invmodal__shdetails_modaltxtrtcopy"
                            onClick={handleCopy}
                          >
                            <MdOutlineContentCopy
                              size={16}
                              style={{ marginLeft: "10px" }}
                            />
                          </span>
                        </Tooltip>
                      ) : (
                        ""
                      )}
                      {data?.c_p_shipment_details?.length &&
                      copied === "sid" ? (
                        <span className="invmodal__shdetails_modaltxtrtcopy">
                          <FcCheckmark
                            size={16}
                            style={{ marginLeft: "10px" }}
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    t("invoice.details.carrierTracking")
                  )}
                </th>
              )}
              {data?.insurance && data?.insurance_type === "Package" && (
                <th className="invmodal__shdetails_tablehd">
                  {t("invoice.summary.insuranceAmount")}
                </th>
              )}
              <th className="invmodal__shdetails_tablehd">
                {t("invoice.details.dimensions")}
              </th>
              <th className="invmodal__shdetails_tablehd">
                {t("invoice.details.weight")}
              </th>
              <th className="invmodal__shdetails_tablehd">
                {t("invoice.details.volume")}
              </th>
            </thead>

            <tbody>
              {data?.shipment_details?.map((item, index) => {
                return (
                  <tr key={index}>
                    {" "}
                    <td className="invmodal__shdetails_tableitem content_center">
                      {index + 1}
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {item.description ?? "-"}
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      <HyperLink code={item?.parcel_id} />
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <StatusIcons
                          status={item?.tracking_status ?? "N/A"}
                          showTitle={type !== "Print"}
                          isPrint={type === "Print"}
                          noBg={type === "Print"}
                          noDot={type === "Print"}
                        />

                        {item?.parcel_id &&
                          item?.tracking_status &&
                          type !== "Print" && (
                            <Tooltip title={t("invoice.details.viewHistory")}>
                              <div>
                                <MdOutlineHistory
                                  size={15}
                                  className="parcel__history_icone"
                                  onClick={() => setDetailHistoryModal(item.id)}
                                />
                              </div>
                            </Tooltip>
                          )}
                      </div>
                    </td>
                    {data?.c_p_shipment_details?.length > 0 && (
                      <td className="invmodal__shdetails_tableitem">
                        {data?.c_p_shipment_details
                          ? (data.c_p_shipment_details[index]
                              ?.shipment_tracking_id ?? "-")
                          : "-"}
                      </td>
                    )}
                    {data?.insurance && data?.insurance_type === "Package" && (
                      <td className="invmodal__shdetails_tableitem">
                        {item.insurance ?? "-"}
                      </td>
                    )}
                    <td className="invmodal__shdetails_tableitem">
                      {item.length ?? "0"} x{item.width ?? "0"} x
                      {item.height ?? "0"} (
                      {data?.unit === "Imperial" ? "in" : "cm"})
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {item.weight ?? "0"} (
                      {data?.unit === "Imperial" ? "lb" : "kg"})
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {item.volume ?? "0"} (
                      {data?.unit === "Imperial" ? "cbm" : "cbf"})
                    </td>
                  </tr>
                );
              })}

              <tr className="invmshdetails_cnleft_footer">
                <td></td>
                <td className="invmodal__shdetails_tableitem invmshdetails_cnleft_fitemttl">
                  {t("invoice.details.total")}
                </td>
                <td></td>
                <td></td>
                {data?.c_p_shipment_details?.length > 0 && <td></td>}
                {data?.insurance && data?.insurance_type === "Package" && (
                  <td className="invmodal__shdetails_tableitem"></td>
                )}
                <td></td>
                <td className="invmodal__shdetails_tableitem">
                  {data?.total_weight ?? "0"} (
                  {data?.unit === "Imperial" ? "lb" : "kg"})
                </td>
                <td className="invmodal__shdetails_tableitem">
                  {data?.volume ?? "0"} (
                  {data?.unit === "Imperial" ? "cbm" : "cbf"})
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="invmodal__shdetails_cntright">
          {/* <div className="add__dimension_button">
                <div className="add__dimension_buttonicon">
                  <AddIcon />{" "}
                </div>
                <div className="add__dimension_buttontext">
                  Billed Dimension, Weight and Volume
                </div>
              </div> */}
        </div>
      </div>
    </>
  );
};

export default ShipmentDetails;
